import { ViewportScroller } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { PersonInsightsData } from 'src/app/hire-person-search/hire-insights/PersonInsightsData';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { GaEventsService } from 'src/app/_services/ga-events.service';
import { environment } from 'src/environments/environment';
import { FreemiumService } from '../freemium.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SevenDayFreeTrialModalComponent } from '../seven-day-free-trial-modal/seven-day-free-trial-modal.component';
import { TalentInsightsFreeTrialModalComponent } from '../talent-insights-free-trial-modal/talent-insights-free-trial-modal.component';
import { Router } from '@angular/router';

declare var google;
const CONTINENT_MAP = {
  "asia": "142",
  "south america": "005",
  "north america": "021",
  "africa": "002",
  "oceania": "009"
}
@Component({
    selector: 'app-insights-profile-section',
    templateUrl: './insights-profile-section.component.html',
    styleUrls: ['./insights-profile-section.component.scss'],
    standalone: false
})
export class InsightsProfileSectionComponent implements OnInit {
  showInsightsSection: Boolean = false;
  showProfileSection: Boolean = false;
  @Input() tabname: string;
  @ViewChild('contentRef') contentRef: ElementRef;
  @ViewChild('contentUpgrade') contentUpgrade: ElementRef;
  showNewFreetrialForm:boolean=false
  showOldFreetrialForm:boolean=false


  constructor(private aggregationService: AggregationService, private freemiumService: FreemiumService, private viewportScroller: ViewportScroller, private gaService: GaEventsService, private modalService: NgbModal,public router: Router,) {

  }

  ngOnInit() {
    this.showInsightsSection = true;
    this.onTabChange('insights');

    if(this.router.url && this.router.url.includes('talent-insights-free-trial')){
      this.showNewFreetrialForm = true
    }

  }

  onTabChange(type) {
    if(type == 'insights') {
      this.showInsightsSection = true;
      this.showProfileSection = false;
    } else {
      this.showProfileSection = true;
      this.showInsightsSection = false;

    }
  }

  refreshInsightsProfileData(event) {
    console.log(event);
  }

  scrollToTrial(event) {
    //   if(event.type == 'modal') {
    //  this.contentUpgrade.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

    //   } else {
    //     const elementY = this.contentUpgrade.nativeElement.offsetTop;
    //     this.viewportScroller.scrollToPosition([0, elementY]);
    //   }

    /**
    * GA tracking for get insights button click
    */
     if(this.router.url && this.router.url.includes('try-talent-insights')){
      const modalRef = this.modalService.open(SevenDayFreeTrialModalComponent, { windowClass: 'day-trail-model', backdrop: 'static', centered: true })
      this.gaService.trackButtonClick(event.eventName);
     }else if(this.router.url && this.router.url.includes('talent-insights-free-trial')){
      const modalRef = this.modalService.open(TalentInsightsFreeTrialModalComponent, { windowClass: 'day-trail-model', backdrop: 'static', centered: true })
            this.gaService.trackButtonClick(event.eventName);
     }
  }



}
